<template>
    <div class="ItemModalContainer">
        <button @click="insertRecord" class="openModalButton" :disabled="!isActive" v-html="openModalButton"></button>
        <div v-if="modalActive" class="modal" @click.self="hideModal">
            <div class="modalForm"  @keydown.esc="hideModal">
                <h2 class="modalTitle">{{modalActionText}} {{itemName}}</h2>
                <div class="formRow" v-for="row in formRows" :key="row.name">
                    <div v-if="showRow(row.showIf)">
                        <span class="inputTitle" v-if="row.element !== 'button'">
                            <span v-if="row.required">*</span>
                            {{row.name}}
                        </span>
                        <input v-if="row.element === 'input'" type="text" v-model="item[row.propertyName]" />
                        <input v-if="row.element === 'checkbox'" type="checkbox" v-model="item[row.propertyName]" />
                        <input v-if="row.element === 'date'" type="date" v-model="item[row.propertyName]" />
                        <textarea v-if="row.element === 'textarea'" v-model="item[row.propertyName]"></textarea>
                        <select v-if="row.element === 'select'" v-model="item[row.propertyName]">
                            <option v-for="opt in currentOptions[row.propertyName]" :key="opt.value" :value="opt.internalName">{{opt.displayName}}</option>
                        </select>
                        <Multiselect v-if="row.element === 'multiselect'"
                                    v-model="item[row.propertyName]"
                                    :options="currentOptions[row.propertyName]"
                                    track-by="value"
                                    label="displayName"
                                    placeholder="Type to search"
                                    open-direction="bottom"
                                    :multiple="true"
                                    :searchable="true"></Multiselect>
                        <ConditionalJson v-if="row.element === 'conditionalJson'" 
                                        class="conditionalJson"
                                        :jsonText="item[row.propertyName]"
                                        :object="row" :showTitle="false"
                                        @saveConditionalJsonChanges="saveConditionalJsonChanges"></ConditionalJson>
                        <DisplayText v-if="row.element === 'displayText'" :displayText="item[row.propertyName]" :showLabel="false"
                            :onChanged="saveDisplayText" :object="item" :disabled="false" textPropertyName="row.propertyName"></displayText> 
                        <button v-if="row.element == 'button'" @click="row.onClick" :class="row.class">{{ row.name }}</button>
                        <span v-if="row.maxLength" class="lengthCounter">
                            <span v-if="item[row.propertyName]">{{item[row.propertyName].length}}</span>
                            <span v-if="!item[row.propertyName]">0</span>
                            /{{row.maxLength}} Characters</span>
                        <p v-if="row.element === 'text'">{{ row.text }}</p>
                    </div>
                </div>
                <div class="formRow">*Required</div>
                <div class="formRow">
                    <button @click="hideModal" class="cancelButton" :disabled="saving">Cancel</button>
                    <button @click="saveItem" class="saveButton" :disabled="saving">
                        <span v-if="!saving">Save {{itemName}}</span>
                        <span v-if="saving">Saving...</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ConditionalJson from '@/components/shared/ConditionalJson.vue';
import DisplayText from '@/components/shared/DisplayText.vue';
import Multiselect from 'vue-multiselect';

export default {
    name: 'ItemModal',
    components: {ConditionalJson, DisplayText, Multiselect},
    props: {
        itemName: {
            type: String
        },
        formRows: {
            type: Array,
            default: () => []
        },
        saveItemFunction: {
            type: Function
        },
        refreshItemsFunction: {
            type: Function
        },
        isActive: {
            type: Boolean,
            default: true
        },
        parentId: {
            type: Number
        },
        openModalButton: {
            type: String,
            default: '<i class="fa-circle-plus fas fa-2xl"></i>'
        },
        passThruObject: Object
    },
    data: function() {
        return {
            modalActive: false,
            item: {} ,
            inputData: {},
            inputId: null,
            saving: false
        }
    },
    computed: {
        modalActionText () {
            if(this.inputId != null)
                return "Edit";
            else
                return "Create New";
        },
        currentOptions() {
            var allOptions = {};

            this.formRows.forEach(row => {
                if(row.dependentField && row.availableOptions) {
                    row.availableOptions.forEach(optionObject =>  {
                        if(optionObject.compareValue == this.item[row.dependentField]) {
                            allOptions[row.propertyName] = optionObject.options;
                        }
                    } );
                } 
                else
                    allOptions[row.propertyName] = row.selectOptions;
            });

            return allOptions;
        },
    },
    mounted() {
        document.addEventListener("keydown", (e) => {
            if(!this.modalActive) return;
            if (e.key == 'Enter')
                this.saveItem();
            if (e.key == 'Escape')
                this.hideModal();
        });
    },
    methods: {
        showRow: function(showIf) {
            if(!showIf)
                return true;
            if(showIf.equals) {
                if(this.item[showIf.propertyName] === showIf.value)
                    return true;
                else
                    return false;
            } else {
                if(this.item[showIf.propertyName] !== showIf.value)
                    return true;
                else
                    return false;
            }
        },
        editRecord: function(id, values) {
            this.inputId = id;
            this.inputData = values;
            this.showModal();
        },
        insertRecord: function() {
            this.inputId = null;
            this.inputData = {};
            this.showModal();
        },
        showModal: function() {
            this.emptyItem();
            if(this.inputData) {
                for(var i = 0; i < this.formRows.length; i++) {
                    if(this.inputData[this.formRows[i].propertyName])
                        this.item[this.formRows[i].propertyName] = this.inputData[this.formRows[i].propertyName];
               }
            }

            this.modalActive = true;
        },
        hideModal: function() {
            this.modalActive = false;
            this.inputId = null;
//           this.emptyItem();
        },
        saveItem: async function() {
            var vm = this;
            var error = '';

            this.formRows.forEach(function(row) {
                //check to make sure that we don't have a value set behind the scenes from cascading 
                if(row.dependentField && vm.item[row.propertyName]) {
                    if(!vm.currentOptions[row.propertyName].find(search => search.internalName == vm.item[row.propertyName]))
                        vm.item[row.propertyName] = '';
                }

                if(row.required) {
                    if(typeof row.required === 'boolean') {
                        if(typeof vm.item[row.propertyName] === 'string') {
                            if(!vm.item[row.propertyName] || vm.item[row.propertyName].trim() === "") {
                                error += row.name + ' is required <br />';
                                return;
                            }
                        } else if(Array.isArray(vm.item[row.propertyName])) {
                            if(!vm.item[row.propertyName] || vm.item[row.propertyName].length === 0) {
                                error += row.name + ' is required <br />';
                                return;
                            }
                        }
                    } else if(typeof row.required === 'object') {
                        if(row.required.equals) {
                            if(vm.item[row.required.propertyName] === row.required.value && !vm.item[row.propertyName]) {
                                error += row.name + ' is required <br />';
                                return;
                            }
                        } else {
                            if(vm.item[row.required.propertyName] !== row.required.value && !vm.item[row.propertyName]) {
                                error += row.name + ' is required <br />';
                                return;
                            }
                        }
                        
                    }
                }
                if(row.maxLength && vm.item[row.propertyName] && vm.item[row.propertyName].length > row.maxLength) {
                    error += row.name + ' cannot be longer than ' + row.maxLength + ' characters.<br />';
                }
                if(row.minValue && vm.item[row.propertyName] < row.minValue) {
                    error += row.name + ' cannot be less than ' + row.minValue + '.<br />';
                }
                if(row.maxValue && vm.item[row.propertyName] > row.maxValue) {
                    error += row.name + ' cannot be greater than ' + row.maxValue + '.<br />';
                }
            });
            
            if(error != '') {
                vm.$toast.error(error, {duration: 3000});
                return;
            }

            //add id to the record if it was passed in.
            if(this.inputId)
                this.item["id"] = this.inputId;
            else 
                this.item.isActive = true;

            var retObject;

            this.saving = true; 
            if(this.parentId)
                retObject = await this.saveItemFunction(this.parentId, this.item);
            else if(this.passThruObject)
                retObject = await this.saveItemFunction(this.item, this.passThruObject);
            else
                retObject = await this.saveItemFunction(this.item);
            this.saving = false;

            if(retObject && retObject.success) {
                this.hideModal();
                if(this.refreshItemsFunction)
                    this.refreshItemsFunction();
            }
        },
        emptyItem: function() {
            var vm = this;
            vm.item = {};
            this.formRows.forEach(function(row) {
                switch(row.element) {
                    case 'input':
                    case 'textarea':
                    case 'conditionalJson':
                        vm.item[row.propertyName] = '';
                        break;
                    case 'select':
                        vm.item[row.propertyName] = '';
                        break;
                    case 'checkbox':
                        vm.item[row.propertyName] = false;
                        break;
                    case 'multiselect':
                        vm.item[row.propertyName] = [];
                        break;
                    default:
                        break;
                }
            });

            if(vm.item["id"])
                vm.item["id"] = null;
        },
        saveConditionalJsonChanges: function(jsonText, row) {
            this.item[row.propertyName] = jsonText;
        },
        saveDisplayText: async function(item, newValue, fieldName) {
            item[fieldName] = newValue;
        }
    }
}
</script>

<style scoped src="@/assets/css/shared/itemModal.css"></style>